export default __webpack_public_path__ + "static/media/db_daping.60e98c03.svg";